export default "/images/2cef30099e15b32aed7510d2594dbedb.avif";